export const endpoints = {
  auth: {
    login: "/auth/login",
    register: "/auth/register"
  },
  user: {
    profile: "/user/profile",
    addresses: "/user/addresses"
  },
  locations: {
    active: "/locations/active"
  },
  addresses: {
    add: "/addresses"
  },
  products: {
    categories: "/products/categories",
    list: "/products"
  },
  cart: {
    add: "/cart/add",
    bulkAdd: "/cart/bulk-add",
    list: "/cart",
    decrement: "/cart/decrement",
    increment: "/cart/increment",
    update: "/cart/update"
  },
  order: {
    create: "/orders",
    list: "/orders"
  }
};

// export const baseUrl = "http://localhost:3000";
export const baseUrl = "https://api.greenyogi.in";
